import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { PWAStore } from '../store/pwa.store';

@Component({
  selector: 'app-update-pwa-button',
  template: `
    <button
      *ngIf="pwaStore.showUpdateButton()"
      matRipple
      (click)="pwaStore.updatePWA()"
      [ngClass]="customClass()"
      class="fixed left-0 z-50 p-2 m-4 text-white rounded-full shadow-lg bottom-14 md:bottom-0 bg-gradient-to-l transition-all duration-400 from-violet-500 via-indigo-400 to-sky-400 hover:to-violet-500 hover:via-indigo-400 hover:from-sky-400"
      [ngStyle]="{
        width: '10rem'
      }"
    >
      <span class="flex items-center justify-center min-h-8 space-x-2 relative">
        <svg
          class="  "
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M8 17h8q.425 0 .713-.288T17 16t-.288-.712T16 15H8q-.425 0-.712.288T7 16t.288.713T8 17m3-6.85l-.9-.875Q9.825 9 9.413 9t-.713.3q-.275.275-.275.7t.275.7l2.6 2.6q.3.3.7.3t.7-.3l2.6-2.6q.275-.275.287-.687T15.3 9.3q-.275-.275-.687-.288t-.713.263l-.9.875V7q0-.425-.288-.712T12 6t-.712.288T11 7zM12 22q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22"
          />
        </svg>

        <span class="  whitespace-nowrap transition-all duration-100 px-2">Actualizar</span>
      </span>
    </button>
  `,
  imports: [CommonModule],
  standalone: true
})
export class UpdatePwaButton {
  customClass = input('');
  pwaStore = inject(PWAStore);
}
